<template>
  <div>
    <div class="card">
      <h3 class="card-title">{{ esEdicion ? 'Editar micrositio' : 'Crear micrositio' }}</h3>
      <div class="cols2">
        <pd-input
          type="text"
          id="nombre"
          v-model="form.nombre"
          placeholder="Nombre del micrositio"
          label="Nombre"
        ></pd-input>
        <pd-input
          type="number"
          id="orden"
          v-model="form.orden"
          placeholder="0"
          label="Orden"
        ></pd-input>
        <div class="form-group">
          <label class="form-label">Estado</label>
          <select class="form-control" v-model="form.activo">
            <option :value="true">Activo</option>
            <option :value="false">Inactivo</option>
          </select>
        </div>
      </div>
      <div class="form-group my-1">
        <label class="form-label">Descripción</label>
        <textarea class="form-control" rows="3" v-model="form.descripcion" placeholder="Descripción breve del micrositio"></textarea>
      </div>
      <div class="d-flex space-between">
        <router-link :to="{ name: 'ListarMicrositios' }" class="btn btn-info">
          Cancelar
        </router-link>
        <button class="btn btn-primary" @click="guardar">Guardar</button>
      </div>
    </div>
    <div class="card" v-if="form.nombre">
      <h4 class="card-title">Previsualización</h4>
      <div
        class="card card-interes"
        style="max-width: 300px"
      >
        <h4 class="card-title">{{ form.nombre }}</h4>
        <p v-if="form.descripcion">{{ form.descripcion }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { MicrositiosServices } from '../services/MicrositiosServices';
import Swal from 'sweetalert2';

export default {
  name: 'FormMicrositio',
  data() {
    return {
      form: {
        nombre: '',
        descripcion: '',
        activo: true,
        orden: 0,
      },
    };
  },
  computed: {
    esEdicion() {
      return !!this.$route.params.id;
    },
  },
  created() {
    if (this.esEdicion) {
      MicrositiosServices.api
        .find(this.$route.params.id)
        .then((data) => {
          this.form = {
            nombre: data.micrositio.nombre,
            descripcion: data.micrositio.descripcion || '',
            activo: !!data.micrositio.activo,
            orden: data.micrositio.orden,
          };
        })
        .catch(() => {
          Swal.fire('Error', 'No se pudo cargar el micrositio', 'error');
        });
    }
  },
  methods: {
    guardar() {
      if (!this.form.nombre) {
        Swal.fire('Atención', 'El nombre es obligatorio', 'warning');
        return;
      }
      const request = this.esEdicion
        ? MicrositiosServices.api.put(this.$route.params.id, this.form)
        : MicrositiosServices.api.save(this.form);

      request
        .then((response) => {
          if (response.success) {
            Swal.fire('Éxito', 'Micrositio guardado correctamente', 'success');
            this.$router.push({ name: 'ListarMicrositios' });
          } else {
            Swal.fire('Error', 'No se pudo guardar', 'error');
          }
        })
        .catch((error) => {
          Swal.fire('Error', `Error de servidor: ${error}`, 'error');
        });
    },
  },
};
</script>
